import React, {useEffect, useState} from "react"
import MoreDropdown, {DropAction} from "../../../buttons/moreDropdown/MoreDropdown"
import MoneyOffIcon from "@mui/icons-material/MoneyOffTwoTone"
import CancelIcon from "@mui/icons-material/CancelTwoTone"
import ReplaceIcon from "@mui/icons-material/AutorenewTwoTone"
import CreditCard from "@mui/icons-material/CreditCard"
import EditIcon from "@mui/icons-material/Edit"
import RefreshIcon from "@mui/icons-material/Refresh"
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart"
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket"
//import {Cancel} from "./Cancel"
import {HistoricalRefundData} from "./Refund/Refund"
//import {Replace} from "./Replace"
import {LineItem} from "../../../../dtos/orderResponse"
import {RefundInfo} from "../../../../dtos/refundInfo"
import {Credit} from "./Credit/Credit"
import {UpdateDocument} from "./UpdateDocument"
import {CreditAndAddToCart} from "./CreditAndAddToCart"
import PermissionValidator from "../../../../services/coam/PermissionValidator"
import {OrderCredits} from "../../../../services/order/CreditDetails"
import {postActionLog, ButtonActionTypes} from "../../../../services/order/TrackOrderActions"
import {getCaseId} from "../../../../utils/UrlParser"
import {Event} from "../../../../dtos/eventResponse"
import {isLineItemRejected} from "../../../../services/order/eventHelper"
import {AddToCart} from "./AddToCart"
import {OrderActionTrigger} from "@commercehub/order"
import {
	CREDIT_DISABLED_TOOLTIP,
	RESTRICTED_PAYMENT,
} from "../../../../utils/paymentCreditRestrictions"
import OrderService from "../../../../services/order/OrderService"
import * as Order from "../../../../dtos/orderResponse"

const caseId = getCaseId()
const svc = new OrderService()
interface LineItemActionProps {
	updateLineItem: () => void
	customerId: string
	orderId: string
	order: Order.Order
	orderIsLegacy: boolean
	lineItem: LineItem
	orderNumber: string
	orderRefInfo: RefundInfo
	culture: string
	isAnonymousCustomer: boolean
	tenantId: string
	cartId: string
	isFullyPaidWithMC: boolean
	paymentFullySuccessful: boolean
	historicalRefundData: HistoricalRefundData
	orderCredits: OrderCredits | null
	orderIsReleasedToFulfillment: boolean
	stateChangedEvents: Event[] | undefined
	isVCSAgent: boolean
	isVCSOrder: boolean
	events: Event[]
	defaultCountryCode: string
	isPayOnBillingAccountOrder: boolean
	isCompanyCardOrder: boolean
}

export function LineItemAction(props: LineItemActionProps) {
	const {lineItem} = props
	const [cancelOpen, setCancelOpen] = useState(false)
	const [refundOpen, setRefundOpen] = useState(false)
	const [merchandiseCreditOpen, setMerchandiseCreditOpen] = useState(false)
	const [replaceOpen, setReplaceOpen] = useState(false)
	const [updateDocumentOpen, setUpdateDocumentOpen] = useState(false)
	const [creditAndAddToCart, setCreditAndAddToCart] = useState(false)
	const [addToCart, setAddToCart] = useState(false)
	const [issuableAmountsForMC, setIssuableAmountsForMC] = useState<any>(null)
	const [hasAddToCart, setHasAddToCart] = useState(false)

	// function isTerminalState(): boolean {
	// 	const lineItemStateReducer = (accumulator: boolean, current: LineItemState) => {
	// 		if (accumulator)
	// 			return ["Cancelled", "CancelRequested", "Completed", "Shipped"].includes(current.state)
	// 		return accumulator
	// 	}
	// 	const isTerminalState = props.lineItem.states.reduce(lineItemStateReducer, true)
	// 	return isTerminalState
	// }

	useEffect(() => {
		async function checkPermissions() {
			const permissionValidator = new PermissionValidator()
			const permission = await permissionValidator.hasPermission("care-console", "*", "copy:cart")
			setHasAddToCart(permission)
		}
		checkPermissions()
	}, [])

	function editItemDocument() {
		logActionToSnowflake(ButtonActionTypes.ClickEditItemButton)
		window.open(`${props.lineItem.editDocumentUrl}&careAgent=true&owner=${props.customerId}`)
	}

	function shouldDisableEditDocument() {
		return (
			(props.isVCSOrder && !props.isVCSAgent) ||
			props.orderIsLegacy ||
			!props.lineItem.editDocumentUrl ||
			props.lineItem.editDocumentUrl === "" ||
			props.lineItem.editDocumentUrl.includes("/albelli")
		)
	}
	useEffect(() => {
		const getIssuableAmountsForMC = async (orderNumber: string) => {
			const issuableAmountsForMC = await svc.getIssuableAmountsForMC(orderNumber)
			setIssuableAmountsForMC(issuableAmountsForMC)
		}
		getIssuableAmountsForMC(props.orderNumber)
	}, [props.orderNumber])

	function shouldDisableReplaceItem() {
		if (props.orderIsLegacy) {
			return true
		}
		if (!props.orderIsReleasedToFulfillment) {
			return true
		}
		if (props.isVCSOrder && !props.isVCSAgent) {
			return true
		}

		return props.lineItem.customOrderData &&
			props.lineItem.customOrderData.order &&
			props.lineItem.customOrderData.order.postOrderActionOverrides &&
			props.lineItem.customOrderData.order.postOrderActionOverrides.replacement
			? props.lineItem.customOrderData.order.postOrderActionOverrides.replacement.disabled
			: false
	}

	const logActionToSnowflake = (action: string) => {
		postActionLog(
			{
				event: action,
				actionMetaData: {
					orderNumber: props.orderNumber,
					lineItemId: props.lineItem.id,
				},
			},
			caseId
		)
	}

	const dropOptions: Array<DropAction> = [
		{
			title: "Cancel item",
			//if it is VCS Order and it is not a vcs agent, cancel item actions should be disabled
			exe: () => {
				logActionToSnowflake(ButtonActionTypes.ClickCancelItemButton)
				setCancelOpen(true)
			},
			icon: cancelIcon,
			disabled:
				(props.isVCSOrder && !props.isVCSAgent) ||
				props.orderIsLegacy ||
				props.lineItem.isCancellable === false,
		},
		{
			title: "Refund item",
			exe: () => {
				logActionToSnowflake(ButtonActionTypes.ClickRefundItemButton)
				setRefundOpen(true)
			},
			icon: refundIcon,
			disabled:
				(props.isVCSOrder && (!props.isVCSAgent || props.isPayOnBillingAccountOrder)) ||
				props.orderIsLegacy ||
				props.lineItem.refundableAmounts.total === 0 ||
				props.isFullyPaidWithMC ||
				(!props.paymentFullySuccessful &&
					!props.order.orderData.payments.some((p) => p.paymentMethod in RESTRICTED_PAYMENT)),
		},
		{
			title: "Credit item",
			exe: () => {
				logActionToSnowflake(ButtonActionTypes.ClickCreditItemButton)
				setMerchandiseCreditOpen(true)
			},
			trackToolTipClick: () => {
				logActionToSnowflake(ButtonActionTypes.HoverDisabledCreditItemToolTip)
			},
			icon: creditIcon,
			disabled:
				(props.isVCSOrder &&
					(!props.isVCSAgent || props.isPayOnBillingAccountOrder || props.isCompanyCardOrder)) ||
				props.isAnonymousCustomer ||
				(props.orderCredits?.totalCreditsIssued?.amountCents === 0 &&
					issuableAmountsForMC?.amountInMinorUnits === 0),
			hint:
				props.orderCredits?.totalCreditsIssued?.amountCents === 0 &&
				issuableAmountsForMC?.amountInMinorUnits === 0
					? CREDIT_DISABLED_TOOLTIP
					: undefined,
		},
		{
			title: "Replace Item",
			exe: () => {
				logActionToSnowflake(ButtonActionTypes.ClickReplaceItemButton)
				setReplaceOpen(true)
			},
			icon: replaceIcon,
			disabled: shouldDisableReplaceItem(),
			hint: getReplacementHint(),
		},
		{
			title: "Edit Document",
			exe: editItemDocument,
			icon: editDocumentIcon,
			disabled: shouldDisableEditDocument(),
		},
		{
			title: "Update Document",
			exe: () => {
				logActionToSnowflake(ButtonActionTypes.ClickUpdateDocumentButton)
				setUpdateDocumentOpen(true)
			},
			icon: UpdateDocumentIcon,
			disabled: shouldDisableEditDocument(),
		},
	]
	if (hasAddToCart) {
		dropOptions.push({
			title: "Credit & Add to Cart",
			exe: () => {
				logActionToSnowflake(ButtonActionTypes.ClickCreditAndAddToCartButton)
				setCreditAndAddToCart(true)
			},
			icon: CreditAndAddToCartIcon,
			disabled:
				(props.isVCSOrder &&
					(!props.isVCSAgent || props.isPayOnBillingAccountOrder || props.isCompanyCardOrder)) ||
				!props.cartId,
		})
	}
	dropOptions.push({
		title: "Add to Cart",
		exe: () => {
			logActionToSnowflake(ButtonActionTypes.ClickAddToCartButton)
			setAddToCart(true)
		},
		icon: AddToCartIcon,
		disabled: (props.isVCSOrder && !props.isVCSAgent) || !props.cartId,
	})
	function getReplacementHint() {
		if (props.orderIsLegacy) {
			return "This is a legacy order, replacements are not allowed."
		} else if (!props.orderIsReleasedToFulfillment) {
			return "Replacements are not allowed on this order where a payment has not been successfully processed. Please check payment status."
		} else if (
			props.isVCSOrder &&
			!props.isVCSAgent &&
			props.lineItem.customOrderData &&
			props.lineItem.customOrderData.order &&
			props.lineItem.customOrderData.order.postOrderActionOverrides &&
			props.lineItem.customOrderData.order.postOrderActionOverrides.replacement
		)
			return "Replacements are not allowed on this item; product is temporarily unavailable."
		return ""
	}

	return (
		<div>
			<MoreDropdown options={dropOptions} />
			{/* <Cancel
				customerId={props.customerId}
				orderNumber={props.orderNumber}
				open={cancelOpen}
				reloadParent={props.updateLineItem}
				close={() => {
					setCancelOpen(false)
				}}
				lineItems={[lineItem]}
			/> */}
			<OrderActionTrigger
				type="cancel-items"
				isOpen={cancelOpen}
				onOpenChange={setCancelOpen}
				onComplete={props.updateLineItem}
				orderId={props.orderNumber}
				selectedItemIds={[lineItem.id]}
			/>
			{/* <Refund
				orderId={props.orderNumber}
				lineItem={lineItem}
				open={refundOpen}
				reloadParent={props.updateLineItem}
				close={() => {
					setRefundOpen(false)
				}}
				historicalRefundData={props.historicalRefundData}
				isTerminalState={isTerminalState()}
				orderCredits={props.orderCredits}
				replacementHistory={lineItem.replacementHistory}
				isLineItemRejected={isLineItemRejected(props.stateChangedEvents)}
				logOverPaymentConfirmYesButton={logActionToSnowflake}
			/> */}
			<OrderActionTrigger
				type="refund-items"
				isOpen={refundOpen}
				onOpenChange={setRefundOpen}
				onComplete={props.updateLineItem}
				orderId={props.orderNumber}
				selectedItemIds={[lineItem.id]}
			/>
			{/* <Credit
				orderId={props.orderNumber}
				lineItem={lineItem}
				open={merchandiseCreditOpen}
				reloadParent={props.updateLineItem}
				close={() => {
					setMerchandiseCreditOpen(false)
				}}
				orderCredits={props.orderCredits}
				historicalRefundData={props.historicalRefundData}
				replacementHistory={lineItem.replacementHistory}
				isLineItemRejected={isLineItemRejected(props.stateChangedEvents)}
				logOverPaymentConfirmYesButton={logActionToSnowflake}
			/> */}
			<OrderActionTrigger
				type="credit-items"
				isOpen={merchandiseCreditOpen}
				onOpenChange={setMerchandiseCreditOpen}
				onComplete={props.updateLineItem}
				orderId={props.orderNumber}
				selectedItemIds={[lineItem.id]}
			/>

			<OrderActionTrigger
				type="replace-items"
				isOpen={replaceOpen}
				onOpenChange={setReplaceOpen}
				onComplete={props.updateLineItem}
				orderId={props.orderNumber}
				selectedItemIds={[lineItem.id]}
			/>
			{/* <Replace
				customerId={props.customerId}
				orderId={props.orderNumber}
				open={replaceOpen}
				reloadParent={props.updateLineItem}
				close={() => {
					setReplaceOpen(false)
				}}
				lineItems={[lineItem]}
				orderCredits={props.orderCredits}
				locale={props.culture}
				events={props.events}
			/> */}

			{/* <UpdateDocument
				orderNumber={props.orderNumber}
				lineItems={[lineItem]}
				open={updateDocumentOpen}
				reloadParent={props.updateLineItem}
				close={() => {
					setUpdateDocumentOpen(false)
				}}
				customerId={props.customerId}
				tenantName={props.tenantId}
				locale={props.culture}
				defaultCountryCode={props.defaultCountryCode}
				isVCSagent={props.isVCSAgent}
				orderIsLegacy={props.orderIsLegacy}
				isVCSorder={props.isVCSOrder}
			/> */}
			<OrderActionTrigger
				type="update-document-items"
				isOpen={updateDocumentOpen}
				onOpenChange={setUpdateDocumentOpen}
				onComplete={props.updateLineItem}
				orderId={props.orderNumber}
				selectedItemIds={[lineItem.id]}
				shopperId={props.customerId}
			/>
			{/* <CreditAndAddToCart
				tenantName={props.tenantId}
				cartId={props.cartId}
				customerId={props.customerId}
				orderNumber={props.orderNumber}
				lineItem={lineItem}
				open={creditAndAddToCart}
				reloadParent={props.updateLineItem}
				close={() => {
					setCreditAndAddToCart(false)
				}}
			/> */}
			<OrderActionTrigger
				type="credit-and-add-to-cart"
				isOpen={creditAndAddToCart}
				onOpenChange={setCreditAndAddToCart}
				onComplete={props.updateLineItem}
				orderId={props.orderNumber}
				selectedItemIds={[lineItem.id]}
				shopperId={props.customerId}
			/>

			{/* <AddToCart
				tenantName={props.tenantId}
				customerId={props.customerId}
				orderNumber={props.orderNumber}
				lineItems={[lineItem]}
				open={addToCart}
				reloadParent={props.updateLineItem}
				close={() => {
					setAddToCart(false)
				}}
			/> */}
			<OrderActionTrigger
				type="add-to-cart"
				isOpen={addToCart}
				onOpenChange={setAddToCart}
				onComplete={props.updateLineItem}
				orderId={props.orderNumber}
				selectedItemIds={[lineItem.id]}
				shopperId={props.customerId}
			/>
		</div>
	)
}

const cancelIcon = () => {
	return <CancelIcon />
}
const refundIcon = () => {
	return <MoneyOffIcon />
}
const replaceIcon = () => {
	return <ReplaceIcon />
}
const creditIcon = () => {
	return <CreditCard />
}
const editDocumentIcon = () => {
	return <EditIcon />
}
const UpdateDocumentIcon = () => {
	return <RefreshIcon />
}
const CreditAndAddToCartIcon = () => {
	return <ShoppingBasketIcon />
}

const AddToCartIcon = () => {
	return <AddShoppingCartIcon />
}
